import { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import SvgLogo from '@public/assets/logo-black.svg';
import { Typography } from 'antd';
import styled from 'styled-components';

import { PageDialog } from '@/shared/layouts/PageDialog';
import { Title } from '@/shared/uikit/Title';

export const MigrationErrorLockScreen: FC = () => {
  const { t } = useTranslation('common', { keyPrefix: 'migrationErrorLockScreen' });
  return (
    <PageDialog>
      <Container>
        <Image src={SvgLogo} alt="logo" width={76} height={48} />
        <TextWrapper>
          <Title style={{ fontSize: 24 }}>{t('title')}</Title>
          <Typography style={{ fontSize: 18 }}>{t('description')}</Typography>
        </TextWrapper>
      </Container>
    </PageDialog>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 24px;
  width: min(548px, calc(100% - 16px));
  min-height: 230px;
  gap: 24px;

  background: white;
  border-radius: 12px;

  position: relative;
  overflow: hidden;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;
`;
